import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

interface JobDeleteDialogProps {
  open: boolean;
  deleteLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function JobDeleteDialog({open, deleteLoading, onCancel, onConfirm}: JobDeleteDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Delete Job</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to delete this job? This action cannot be undone.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={deleteLoading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" disabled={deleteLoading}>
          {deleteLoading ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
